<template>
<div class="chapter">
<div class="inner_page">
<h1 class="head1">Lynet: Under Camelot’s Banner</h1>
<p class="author">The Queens of Camelot</p>
<p class="author"><span class="bold">Sarah Zettel</span></p>
<div class="img_container1">
<img alt="image" src="images/logo.jpg"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?56c6dd98